<div class="flex items-center gap-2 min-w-0 overflow-hidden">
  <p-breadcrumb
    [model]="items"
    styleClass="border-none bg-transparent py-2 !p-0 min-w-0 overflow-hidden"
  >
    <ng-template #item let-item>
      @if (item.routerLink) {
        <a
          [routerLink]="item.routerLink"
          class="flex items-center min-w-0 max-w-full"
        >
          @if (item.icon) {
            <span
              class="material-symbols-outlined text-sm text-white flex-shrink-0 mr-1"
              >{{ item.icon }}</span
            >
          }
          <span
            class="block text-sm font-normal text-white truncate max-w-[80px] sm:max-w-[120px] md:max-w-[180px] lg:max-w-[240px]"
            [pTooltip]="item.label"
            tooltipPosition="bottom"
            [tooltipDisabled]="
              !item.label ||
              (item.data?.showFullLabel
                ? (item.label?.length || 0) < 30
                : item.label.split(' ').length <= 1)
            "
          >
            {{
              item.data?.showFullLabel
                ? item.label
                : item.label?.split(' ')?.at(0)
            }}
          </span>
        </a>
      } @else {
        <div class="flex items-center min-w-0 max-w-full">
          <span
            class="block text-sm text-white truncate max-w-[80px] sm:max-w-[120px] md:max-w-[180px] lg:max-w-[240px]"
            [class.font-semibold]="item.data?.isLast"
            [class.font-normal]="!item.data?.isLast"
            [pTooltip]="item.label"
            tooltipPosition="bottom"
            [tooltipDisabled]="
              !item.label ||
              (item.data?.showFullLabel
                ? (item.label?.length || 0) < 30
                : item.label.split(' ').length <= 1)
            "
          >
            {{
              item.data?.showFullLabel
                ? item.label
                : item.label?.split(' ')?.at(0)
            }}
          </span>
        </div>
      }
    </ng-template>
    <ng-template #separator>
      <i class="pi pi-angle-right text-white text-sm px-1 flex-shrink-0"></i>
    </ng-template>
  </p-breadcrumb>
</div>
